import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { GameGuideHelpButton } from '../components/gameGuideHelpButton';
import { BOLD_FONT_FAMILY } from '../constants/constants';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;
const TITLE_CSS = css `
  flex-grow: 1;
  font-family: ${BOLD_FONT_FAMILY};
  font-size: 16px;
`;
export const PanelHeader = ({ title, color, withPadding, headerLeft, headerRight, gameGuidePageType }) => {
    return (_jsxs("div", { css: CONTAINER_CSS, style: { ...(withPadding ? { padding: '5px' } : undefined), ...(color ? { color } : undefined) }, children: [headerLeft && _jsx("div", { style: { ...(!withPadding ? { padding: '5px' } : undefined) }, children: headerLeft }), _jsxs(Typography, { component: 'div', variant: 'subtitle2', css: TITLE_CSS, children: [title, gameGuidePageType ? (_jsxs(_Fragment, { children: [' ', _jsx(GameGuideHelpButton, { pageType: gameGuidePageType, title: 'More Info' })] })) : undefined] }), headerRight && _jsx("div", { style: { ...(!withPadding ? { padding: '5px' } : undefined) }, children: headerRight })] }));
};
